import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { AppCommonsModule } from '../../../commons/app-commons.module';

import { PlessSharedModule } from '../../../shared/pless-shared.module';

import { KYMW1311Component } from './kymw1311.component';
import { OutputPlanDutiesFormCSVService } from './api-services/output-plan-duties-form-csv.service';


/**
 * 業態別企画書データ出力画面 モジュール設定クラス
 *
 * @export KYMW1311Module
 * @class KYMW1311Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
  ],
  declarations: [
    KYMW1311Component,
  ],
  providers: [
    OutputPlanDutiesFormCSVService,
  ],
})
export class KYMW1311Module {
}
